module.exports = __webpack_public_path__ + "static/img/10.b6c8110.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/19/zh/10.png
// module id = 8k9P
// module chunks = 0